import React, {PureComponent} from 'react';
import {fromLonLat} from "ol/proj";
import Map from "ol/Map";
import TileLayer from "ol/layer/Tile";
import XYZ from "ol/source/XYZ";
import View from "ol/View";
import $ from "jquery";
import Overlay from "ol/Overlay";
import {formatTime} from "../functions/utils";
import LineChart from "../independentComponents/graphComponent";
import flagIcon from "../../img/marshall.png";
import parallel from "async/parallel";
import {withTranslation} from "react-i18next";
import {withCookies} from "react-cookie";

const serverIP = process.env.REACT_APP_SERVER_IP;
const backendPort = process.env.REACT_APP_BACKEND_PORT;

class PopoutLapComparison extends PureComponent {

    constructor(props) {
        super(props);

        this.state = {
            header: <div/>,
            laps: [],
            maxSpeed: 0,
            maxRPM: 0,
            maxThrottle: 0,
            minSpeed: 0,
            minRPM: 0,
            minThrottle: 0,
            showPercent: 0,
            carMarker: null,
            telemetryMinMax: {},
            orderedMetrics: [],
        };

        this.makeLapHeader = this.makeLapHeader.bind(this);
        this.getLapsInfo = this.getLapsInfo.bind(this);
        this.getSessionDetails = this.getSessionDetails.bind(this);
        this.setupMap = this.setupMap.bind(this);
        this.calcMaxes = this.calcMaxes.bind(this);
        this.updateShow = this.updateShow.bind(this);
        this.putSectorMarkers = this.putSectorMarkers.bind(this);
        this.sortMetrics = this.sortMetrics.bind(this);
    }

    /* LIFE CYCLE */
    componentDidMount() {
        parallel([
            (p_callback) => {
                this.getLapsInfo((status) => {
                    p_callback(null, status);
                });
            },
            (p_callback) => {
                this.getSessionDetails((status) => {
                    p_callback(null, status);
                });
            }
        ], (err, result) => {
            parallel([
                (p_callback) => {
                    this.calcMaxes((status) => {
                        p_callback(null, status);
                    });
                },
                (p_callback) => {
                    this.makeLapHeader((status) => {
                        p_callback(null, status);
                    });
                },
                (p_callback) => {
                    this.sortMetrics((status) => {
                        p_callback(null, status);
                    });
                },
                (p_callback) => {
                    this.setupMap((status) => {
                        p_callback(null, status);
                    });
                },
            ], (err, result) => {
                $(".loading").fadeOut();
            });
        });
    }

    /* GET DATA */
    getLapsInfo(callback) {
        const helper = this;
        $.ajax({
            type: 'POST',
            url: serverIP + ':' + backendPort + '/dashboard/getLapFullDetails',
            dataType: 'json',
            headers: {
                'authorization': helper.props.cookies.get("authToken")
            },
            data: {
                lapUUIDs: helper.props.match.params.lapUUIDs,
            },
            success: function (data) {
                if (data && data.length > 0) {
                    helper.setState({
                        laps: data,
                    }, () => {
                        callback("ok");
                    });
                } else {
                    callback("nok");
                }
            },
            error: function (err) {
                if (err) {
                    console.error('Error:', err);
                }
                callback("nok");
            }
        });
    }

    getSessionDetails(callback) {
        const helper = this;
        $.ajax({
            type: 'POST',
            url: serverIP + ":" + backendPort + '/dashboard/getSessionDetails',
            headers: {
                'authorization': helper.props.cookies.get("authToken"),
            },
            data: {
                sessionID: helper.props.match.params.sessionID,
            },
            success: function (data) {
                if (data) {
                    helper.setState({
                        session: data.session,
                        circuit: data.circuit,
                        lengthType: data.length_delimiter,
                        orderType: data.order_factor,
                        eventLength: data.length,
                        circuitLength: data.track_length,
                        circuitTimezone: data.timezone,
                        startTimestamp: (data.start_timestamp ? data.start_timestamp : data.scheduled_start_timestamp),
                        mapCenterLat: data.map_center_lat,
                        mapCenterLng: data.map_center_lng,
                        mapZoomLevel: data.map_center_zoom_level,
                        mapRotation: data.map_rotation,
                    }, () => {
                        callback("ok");
                    });
                } else {
                    helper.setState({
                        sessionOver: true,
                    }, () => {
                        callback("nok");
                    });
                }
            }, error: function (err) {
                if (err) {
                    console.error('Error:', err);
                }
                callback("nok");
            }
        });
    }

    putSectorMarkers() {
        const helper = this;
        $.ajax({
            type: 'POST',
            url: serverIP + ':' + backendPort + '/dashboard/getSectorInfo',
            dataType: 'json',
            headers: {
                'authorization': helper.props.cookies.get("authToken")
            },
            data: {
                eventID: this.props.match.params.sessionID
            },
            success: function (data) {
                if (data.length > 0) {
                    let currentSector = 0;
                    for (let i = 0; i < data.length; i++) {

                        let flagText = '';
                        if ([0, 3, 6].includes(data[i].order_no)) {
                            currentSector++;
                            flagText = 'P' + (data[i].order_no + 1) + ' / S' + currentSector;
                        } else {
                            flagText = 'P' + (data[i].order_no + 1);
                        }

                        const innerDiv = $('' +
                            '<div class="sectorFlag" style="height: 55px;width: 65px;">' +
                            '<span class="sectorText" style="font-size: 11px">' + flagText + ' </span>' +
                            '<img style="height: 100%; width:100%" src="' + flagIcon + '" alt="sector"/>' +
                            '</div>' +
                            '').get(0);

                        helper.map.addOverlay(
                            new Overlay({
                                id: "sector_" + (i + 1),
                                element: innerDiv,
                                position: fromLonLat([data[i].internal_point_lng, data[i].internal_point_lat]),
                                offset: [-2, 4],
                                positioning: 'bottom-left',
                            })
                        );
                    }
                }
            },
            error: function (err) {
                if (err) {
                    console.error('Error:', err);
                }
                return false;
            }
        });
    }

    /* SETUP */
    setupMap(callback) {
        this.map = new Map({
            target: "map",
            layers: [
                new TileLayer({
                    source: new XYZ({
                        attributions: 'Tiles © <a href="https://services.arcgisonline.com/arcgis/rest/services/World_Imagery/MapServer">ArcGIS</a>',
                        url: 'https://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}'
                    })
                }),
            ],
            view: new View({
                center: fromLonLat([this.state.mapCenterLng, this.state.mapCenterLat]),
                zoomFactor: 1.1,
                zoom: this.state.mapZoomLevel - 5,
                maxZoom: 141,
                rotation: this.state.mapRotation,
            }),
            loadTilesWhileAnimating: true,
            loadTilesWhileInteracting: true,
        });

        const innerDiv_1 = $('' +
            '<div id="car_id_marker">' +
            '   <span class="fa-stack carPin">' +
            '       <i class="fa fa-circle fa-stack-2x" style="color: #b00b0d;line-height: inherit;"/><i class="fa fa-car fa-stack-1x fa-inverse" style="font-size:15px;margin:inherit"/>' +
            '   </span>' +
            '</div>').get(0);

        const innerDiv_2 = $('' +
            '<div id="car_id_marker">' +
            '   <span class="fa-stack carPin">' +
            '       <i class="fa fa-circle fa-stack-2x" style="color: #ff8c00;line-height: inherit;"/><i class="fa fa-car fa-stack-1x fa-inverse" style="font-size:15px;margin:inherit"/>' +
            '   </span>' +
            '</div>').get(0);


        this.setState({
            marker_1: new Overlay({
                id: "carMarker_Details_1",
                element: innerDiv_1,
                position: fromLonLat([0, 0]),
                offset: [0, 10],
                positioning: 'bottom-center',
            }),
            marker_2: new Overlay({
                id: "carMarker_Details_2",
                element: innerDiv_2,
                position: fromLonLat([0, 0]),
                offset: [0, 10],
                positioning: 'bottom-center',
            })

        }, () => {
            this.map.addOverlay(this.state.marker_1);
            this.map.addOverlay(this.state.marker_2);
            this.putSectorMarkers();
            callback("ok");
        });
    }

    calcMaxes(callback) {
        let telemetry_min_max = {};
        Object.keys(this.state.laps[0][1].labels).forEach((tag) => {
            if (this.state.laps[0][1].data[tag].length > 0 && this.state.laps[1][1].data[tag].length > 0) {

                let min_1 = Math.min(...this.state.laps[0][1].data[tag]);
                let max_1 = Math.max(...this.state.laps[0][1].data[tag]);
                let min_2 = Math.min(...this.state.laps[1][1].data[tag]);
                let max_2 = Math.max(...this.state.laps[1][1].data[tag]);

                let min = Math.min(...[min_1, min_2]);
                let max = Math.max(...[max_1, max_2]);

                telemetry_min_max[tag] = (min === max ? [0, 0] : [min, max]);
            } else {
                telemetry_min_max[tag] = [0, 0];
            }
        });
        this.setState({
            telemetryMinMax: telemetry_min_max,
        }, () => {
            callback("ok");
        });
    }

    updateShow(index) {

        if (index < this.state.laps[0][1].data.coords.length) {
            this.state.marker_1.setPosition(
                fromLonLat([
                    this.state.laps[0][1].data.coords[index][0],
                    this.state.laps[0][1].data.coords[index][1]
                ])
            );
        } else {
            this.state.marker_1.setPosition(
                fromLonLat([
                    this.state.laps[0][1].data.coords[(this.state.laps[0][1].data.coords.length - 1)][0],
                    this.state.laps[0][1].data.coords[(this.state.laps[0][1].data.coords.length - 1)][1]
                ])
            );
        }

        if (index < this.state.laps[1][1].data.coords.length) {
            this.state.marker_2.setPosition(
                fromLonLat([
                    this.state.laps[1][1].data.coords[index][0],
                    this.state.laps[1][1].data.coords[index][1]
                ])
            );
        } else {
            this.state.marker_2.setPosition(
                fromLonLat([
                    this.state.laps[1][1].data.coords[(this.state.laps[1][1].data.coords.length - 1)][0],
                    this.state.laps[1][1].data.coords[(this.state.laps[1][1].data.coords.length - 1)][1]
                ])
            );
        }
    }

    sortMetrics(callback) {
        let array = [];
        for (let i = 0; i < Object.keys(this.state.laps[0][1].labels).length; i++) {
            array[this.state.laps[0][1].labels[Object.keys(this.state.laps[0][1].labels)[i]].order_no] = Object.keys(this.state.laps[0][1].labels)[i];
        }
        let filtered = array.filter(function (el) {
            return el != null;
        });
        this.setState({
            orderedMetrics: filtered,
        }, () => {
            callback("ok");
        });
    }

    /* RENDER */
    makeLapHeader(callback) {
        let headers = [];
        for (let i = 0; i < this.state.laps.length; i++) {
            headers.push(
                <div key={"lap_" + i} className={"col-sm-5"} style={{marginTop: 15}}>
                    <div className={"App_ContainerStyle clearfix"}>
                        <div className={"col-xs-3 col-lg-2"}>
                            <img className={"img-responsive"}
                                 alt={"PIC"}
                                 src={(this.state.laps[i][0].driver_pic_path) ? (serverIP + ":" + backendPort + "/uploads/drivers/" + this.state.laps[i][0].driver_pic_path.photo_path) : (serverIP + ":" + backendPort + "/uploads/noimage.png")}
                            />
                        </div>
                        <div className={"col-xs-9"}>
                            <div className={"col-xs-12 col-md-6"}>
                                <span className={"App_white_text"} style={{fontSize: 25}}>{this.state.laps[i][0].driver_name}</span> <span className={"App_text"} style={{fontSize: 20, color: "#ff0012"}}>{this.state.laps[i][0].driver_nationality}</span>
                                <p className={"App_white_text"}><b style={{color: "#ff0012"}}>#{this.state.laps[i][0].livery_number}</b> {this.state.laps[i][0].team_name}</p>
                            </div>
                            <div className={"col-xs-12 col-md-6"}>
                                <span className={"App_white_text"}><b style={{color: "#ff0012"}}>{this.props.t("lap")} {this.state.laps[i][0].lap_number}</b></span>
                                <p className={"App_white_text"}>{formatTime(this.state.laps[i][0].time)}</p>
                            </div>
                        </div>
                    </div>
                </div>
            );
            i === (this.state.laps.length - 1) ? headers.push(<div key={"empty"}/>) : headers.push(<div key={"vs_text"} className={"col-sm-2 versusText"}>VS</div>);
        }

        this.setState({
            header: (
                <div className={"row w3-animate-fading"} style={{marginTop: 5}}>
                    {headers}
                </div>
            ),
        }, () => {
            callback("ok");
        });
    }

    render() {
        return (
            <div className={"container-fluid"}>
                <div className="loading">
                    <div className={"loading-text hidden-sm hidden-xs"}>{this.props.t("processing")}</div>
                </div>
                {this.state.header}
                <div className={"row"}>
                    <div className={"col-xs-12"} style={{height: 270, width: "100%", marginTop: 15}} id={"map"}/>
                </div>
                {this.state.laps.length > 0 && this.state.laps.length > 0 ? (
                    <div className={"row"} style={{width: "100%", marginTop: 15}}>
                        <div className={"col-xs-6"}>
                            {this.state.orderedMetrics.map((tag) => {
                                if (Object.keys(this.state.telemetryMinMax).length > 0 && this.state.telemetryMinMax[tag][1] > 0) {
                                    console.log("WOWOW");
                                    return (
                                        <div className={"col-xs-12"} key={"graph_" + tag}>
                                            <LineChart
                                                dataName={this.state.laps[0][1].labels[tag][localStorage.getItem("i18nextLng")]}
                                                data={this.state.laps[0][1].data[tag]}
                                                hoverTriggerIndex={[true, false]}
                                                minYAxis={this.state.laps[0][1].labels[tag].unit === "%" ? 0 : this.state.telemetryMinMax[tag][0]}
                                                maxYAxis={this.state.laps[0][1].labels[tag].unit === "%" ? 100 : this.state.telemetryMinMax[tag][1]}
                                                unit={this.state.laps[0][1].labels[tag].unit}
                                                showPercent={this.state.showPercent}
                                                updateShow={this.updateShow}
                                            />
                                        </div>
                                    );
                                } else {
                                    return null;
                                }
                            })}
                        </div>
                        <div className={"col-xs-6"}>
                            {this.state.orderedMetrics.map((tag) => {
                                if (Object.keys(this.state.telemetryMinMax).length > 0 && this.state.telemetryMinMax[tag][1] > 0) {
                                    return (
                                        <div className={"col-xs-12"} key={"graph_" + tag}>
                                            <LineChart
                                                dataName={this.state.laps[1][1].labels[tag][localStorage.getItem("i18nextLng")]}
                                                data={this.state.laps[1][1].data[tag]}
                                                hoverTriggerIndex={[true, false]}
                                                minYAxis={this.state.laps[1][1].labels[tag].unit === "%" ? 0 : this.state.telemetryMinMax[tag][0]}
                                                maxYAxis={this.state.laps[1][1].labels[tag].unit === "%" ? 100 : this.state.telemetryMinMax[tag][1]}
                                                unit={this.state.laps[1][1].labels[tag].unit}
                                                showPercent={this.state.showPercent}
                                                updateShow={this.updateShow}
                                                color={"#ffa200"}
                                            />
                                        </div>
                                    );
                                } else {
                                    return null;
                                }
                            })}
                        </div>
                    </div>
                ) : (
                    <div/>
                )}
            </div>
        );
    }
}

export default withTranslation("translations")(withCookies(PopoutLapComparison));